import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Client } from '../../http';

export type AddonKind = 'recurring' | 'one_time';

export interface Addon {
  id: string;
  name: string;
  kind: AddonKind;
  price_cents: number;
  currency: string;
  status: string;
  chargebee_url?: string;
}

export interface addonsState {
  value: Array<Addon>;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: addonsState = {
  value: [],
  status: 'idle',
};

export const fetchAddons = createAsyncThunk('addons/fetchAddons', async () => {
  const response = await Client.get<Addon[]>('/api/v1/admin/addons');
  return response.data;
});

export const addonsSlice = createSlice({
  name: 'addons',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddons.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAddons.fulfilled, (state, action) => {
        state.status = 'idle';
        state.value = action.payload;
      })
      .addCase(fetchAddons.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export default addonsSlice.reducer;
